// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__kE_VZ","error":"styles_error__2Z6qo","info":"styles_info__A7NM5","message":"styles_message__5JjDn","details":"styles_details__2BpUj"};